export * from './src/restaurants-menus-v1-item-items.meta.js';
